export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/testimonial/updateTestimonial',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allTestimonials'],
       
    })
